import { type GenericExposeListing, type SearchListingsFilters, isFullListing } from '@pkgs/api';

type GetShopIdFromPageContextParams = {
  listing?: GenericExposeListing;
  filters?: Pick<SearchListingsFilters, 'masterDataShopIds' | 'shopIds'>;
};

export const getShopIdFromPageContext = ({ listing, filters }: GetShopIdFromPageContextParams): string | undefined => {
  if (listing && isFullListing(listing)) {
    return listing.trackingData?.masterDataShopID ?? listing.masterDataShopId ?? listing.shopId;
  }

  return filters?.masterDataShopIds?.[0] ?? filters?.shopIds?.[0];
};
